import React from "react"
import PropTypes from "prop-types"
import { Route, Switch, Redirect } from "react-router-dom"
import { KR_THEME } from "ksc-portal-shareable-configs/dist/webpack/webpack-foundation/constants"
import theme from "../../utils/theme"
import { AVAILABLE_HOMEPAGE_OPTIONS } from "./constants"
import AsyncComponent from "../../../../Applications/Utilities/Async/UserSettings"

import UserSettingsSidebar from "./components/UserSettingsSidebar"
import UserSettingsGeneral from "./views/UserSettingsGeneral"
// import UserSettingsModule from "./views/UserSettingsModule"

export const modulesReady = ["srb"]

const UserSettings = ({
  moduleData,
  settings,
  patchRequest,
  storeSettings,
  replaceSidebar,
  closeSidebar,
  history,
  register,
  availableModules,
}) => {
  const userModules = availableModules || []

  // Similar to componentDidMount
  const hub = theme === KR_THEME.theme

  const defaultHomepageOptions = moduleData.filter(
    ({ path }) =>
      AVAILABLE_HOMEPAGE_OPTIONS.includes(path) &&
      userModules.includes(path.slice(1))
  )

  const filteredModulesData = moduleData.filter(({ path }) => {
    const mod = path.slice(1)
    return userModules.includes(mod) && modulesReady.includes(mod)
  })
  return (
    <div className="portal-user-settings__container">
      <div className="flex">
        {hub ? (
          <div className="portal-user-settings__home flex">
            {!!filteredModulesData.length && (
              <UserSettingsSidebar moduleData={filteredModulesData} />
            )}
            <Switch>
              <Route exact path="/user-settings/general">
                <UserSettingsGeneral
                  replaceSidebar={replaceSidebar}
                  closeSidebar={closeSidebar}
                  defaultHomepageOptions={defaultHomepageOptions}
                  settings={settings}
                  patchRequest={patchRequest}
                  storeSettings={storeSettings}
                  history={history}
                />
              </Route>
              {filteredModulesData.map(({ path }) => {
                const module = path.slice(1)
                return (
                  <Route
                    key={module}
                    exact
                    path={`/user-settings/modules/${module}`}
                  >
                    <AsyncComponent
                      history={history}
                      moduleProvider={register(
                        module,
                        import(
                          `../../../../client/src/BoltOnModules/proxy/lazy/${module}/settings`
                        ),
                        true,
                        true
                      )}
                    />
                  </Route>
                )
              })}
              <Redirect to="/user-settings/general" />
            </Switch>
          </div>
        ) : (
          <Switch>
            <Route exact path="/user-settings">
              <div key={theme} className="portal-user-settings-theme-container">
                <AsyncComponent
                  moduleProvider={register(
                    theme,
                    import(
                      `../../../../client/src/BoltOnModules/proxy/lazy/${theme}/settings`
                    ),
                    true,
                    true
                  )}
                />
              </div>
            </Route>
            <Redirect to="/user-settings" />
          </Switch>
        )}
      </div>
    </div>
  )
}

UserSettings.propTypes = {
  moduleData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string,
    })
  ),
  settings: PropTypes.shape({
    homepage: PropTypes.string,
  }),
  patchRequest: PropTypes.func.isRequired,
  storeSettings: PropTypes.func.isRequired,
  replaceSidebar: PropTypes.func.isRequired,
  closeSidebar: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
  register: PropTypes.func.isRequired,
  availableModules: PropTypes.arrayOf(PropTypes.string),
}

UserSettings.defaultProps = {
  moduleData: [],
  settings: { homepage: null },
  availableModules: null,
}

export default UserSettings
